import { Button } from '@/components/Elements';
import { useNotShowMobileWarning } from '@/atoms/notShowMobileWarningAtom';
import { useResponsive } from '@/hooks/useResponsive';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from '@headlessui/react';

export const MobileWarningModal = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [notShowMobileWarning, setNotShowMobileWarning] =
    useNotShowMobileWarning();

  const close = () => {
    setNotShowMobileWarning(true);
  };

  return (
    <Transition appear show={isMobile && !notShowMobileWarning}>
      <Dialog
        as="div"
        className="relative z-10 focus:outline-none"
        onClose={close}
      >
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center bg-black/50 p-4 backdrop-blur-xl">
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0 transform-[scale(95%)]"
              enterTo="opacity-100 transform-[scale(100%)]"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 transform-[scale(100%)]"
              leaveTo="opacity-0 transform-[scale(95%)]"
            >
              <DialogPanel className="w-full max-w-md rounded-xl bg-white p-6">
                <DialogTitle
                  as="h3"
                  className="text-base/7 font-medium text-black"
                >
                  {t('ご使用端末について')}
                </DialogTitle>
                <p className="mt-2 text-sm/6 text-black/50">
                  {t(
                    '現在、このアプリケーションはパソコンおよびタブレットでのご利用を推奨しております。'
                  )}
                  <br />
                  <br />
                  {t(
                    '画面サイズの小さいデバイスでは、表示が意図通りに行われない可能性がありますので、できるだけ大きめの画面のデバイスをご使用ください。何卒ご理解のほど、よろしくお願い申し上げます。'
                  )}
                </p>
                <div className="mt-4">
                  <Button onClick={close} className="m-auto" size="sm">
                    {t('閉じる')}
                  </Button>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
